import {
  DELETE_CONTACT,
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT_SUCCESS,
  GET_CONTACT,
  GET_CONTACTS,
  GET_CONTACTS_FAILURE,
  GET_CONTACTS_SUCCESS,
  GET_CONTACT_FAILURE,
  GET_CONTACT_SUCCESS,
} from "./actionTypes";

const initialState = {
  contacts: [],
  contact: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const contacts = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACTS:
      return { ...state, loading: true, error: "" };

    case GET_CONTACTS_SUCCESS:
      return { ...state, contacts: action.payload, loading: false };

    case GET_CONTACTS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    case GET_CONTACT:
      return { ...state, loading: true, error: "" };

    case GET_CONTACT_SUCCESS:
      return { ...state, contact: action.payload, loading: false };

    case GET_CONTACT_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    case DELETE_CONTACT:
      return { ...state, loading: true, error: "" };

    case DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contacts: state.contacts.filter(
          (contact) => contact._id !== action.payload
        ),
      };

    case DELETE_CONTACT_FAILURE:
      return { ...state, error: action.payload, loading: false };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default contacts;
